import Vue from 'vue'
import Router from 'vue-router'

import HomeRoutes from './home'
import BuzzRoutes from './buzz'
import NotificationsRoutes from './notifications'
import FeedsRoutes from './feeds'
// import TimelineRoutes from './timeline'
import SearchRoutes from './search'
import RegisterRoutes from './register'
import LoginRoutes from './login'
import ManageRoutes from './manage'
import AccountRoutes from './account'
import SellpointRoutes from './sellpoint'
import CollectionRoutes from './collections';
import PurchaseRoutes from './purchase'
import DemosRoutes from './demos'
import CreateSellpointRoutes from './create'
import BuypointRoutes from './buypoint'
import OrderpointRoutes from './orderpoint'
import orderpoint from './orderpoint';

import AppChatnBuyRoutes from './appchatnbuy'
import AppCommatRoutes from './appcommat'
import AppStockgumRoutes from './appstockgum'
import AppNaijaTradeMallRoutes from './appnaijatrademall'
import AppWedeliverRoutes from './appwedeliver'
import AppTradeFairGlobalRoutes from './apptradefairglobal'
import AppWebnShopRoutes from './appwebnshop'
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        // {
        //     path: '/.well-known/assetlinks.json',
        //     beforeEnter() {location.href = 'https://...../.well-known/assetlinks.json'}
        // },
        HomeRoutes,
        BuzzRoutes,
        NotificationsRoutes,
        FeedsRoutes,
        // TimelineRoutes,
        SearchRoutes,
        RegisterRoutes,
        LoginRoutes,
        ManageRoutes,
        PurchaseRoutes,
        DemosRoutes,
        AccountRoutes,
        CreateSellpointRoutes,
        CollectionRoutes,
        BuypointRoutes,
        OrderpointRoutes,
        //....//
        AppChatnBuyRoutes,
        AppCommatRoutes,
        AppStockgumRoutes,
        AppNaijaTradeMallRoutes,
        AppWedeliverRoutes,
        AppTradeFairGlobalRoutes,
        AppWebnShopRoutes,
        SellpointRoutes,
        // {path: '*', redirect: '/'} // 404
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js